/* Patch PF request to support div loading*/
PrimeFaces.ajax.Request.collectEarlyPostParams = function(cfg) {
    var earlyPostParams;

    var sourceElement;
    if (typeof(cfg.source) === 'string') {
        sourceElement = $(PrimeFaces.escapeClientId(cfg.source));
    }
    else {
        sourceElement = $(cfg.source);
    }
    if (sourceElement.is(':input') && sourceElement.is(':not(:button)')) {
        earlyPostParams = [];
        earlyPostParams.push({
            name: sourceElement.attr('name'),
            value: sourceElement.is(':checkbox') ? sourceElement.is(':checked') : sourceElement.val()
        });
    }
    else {
        //Rasp patched: Do not collect elements inside .skip-submission
        var skipSubmissionFilter = function (i, e) {
            var skips = $(e).parentsUntil(sourceElement, '.skip-ajax-submission');
            return skips.size() === 0 || (skips.size() === 1 && skips.get(0) === sourceElement);
        };
        earlyPostParams = sourceElement
            .find(':input')
            //Rasp patched: Do not collect elements inside .skip-submission
            .filter(skipSubmissionFilter)
            .serializeArray();
        // jQuery doesn't add unchecked checkboxes
        earlyPostParams = earlyPostParams.concat(
            sourceElement.find('input[type=checkbox]:not(:checked)')
                //Rasp patched: Do not collect elements inside .skip-submission
                .filter(skipSubmissionFilter)
                .map(function() {
                    var $this = $(this);
                    return { 'name': $this.attr('name'), 'value': $this.is(':checked') };
            }).get()
        );
    }

    return earlyPostParams;
};

PrimeFaces.ajax.Request.send = function(cfg) {
    PrimeFaces.debug('Initiating ajax request.');

    PrimeFaces.customFocus = false;

    var global = (cfg.global === true || cfg.global === undefined),
        form = null,
        sourceId = null,
        retVal = null;

    if(cfg.onstart) {
        retVal = cfg.onstart.call(this, cfg);
    }
    if(cfg.ext && cfg.ext.onstart) {
        retVal = cfg.ext.onstart.call(this, cfg);
    }

    if(retVal === false) {
        PrimeFaces.debug('Ajax request cancelled by onstart callback.');

        //remove from queue
        if(!cfg.async) {
            PrimeFaces.ajax.Queue.poll();
        }

        return false;  //cancel request
    }

    $(document).trigger('raspAjaxStart', [cfg]);
    if(global) {
        $(document).trigger('pfAjaxStart');
    }

    //source can be a client id or an element defined by this keyword
    if(typeof(cfg.source) === 'string') {
        sourceId = cfg.source;
    } else {
        sourceId = $(cfg.source).attr('id');
    }

    if(cfg.formId) {
        //Explicit form is defined
        form = PrimeFaces.expressions.SearchExpressionFacade.resolveComponentsAsSelector(cfg.formId);
    }
    else {
        var $source = $(PrimeFaces.escapeClientId(sourceId));
        //look for a parent of source
        form = $source.closest('form');

        //source has no parent form so use first form in document
        if (form.length === 0) {
            form = $('form').eq(0);
        }
    }


    PrimeFaces.debug('Form to post ' + form.attr('id') + '.');

    var postURL = form.attr('action'),
        encodedURLfield = form.children("input[name*='javax.faces.encodedURL']"),
        postParams = [];

    // See #6857 - parameter namespace for porlet
    var parameterPrefix = PrimeFaces.ajax.Request.extractParameterNamespace(form);

    //portlet support
    var portletFormsSelector = null;
    if(encodedURLfield.length > 0) {
        portletFormsSelector = 'form[id*="' + parameterPrefix + '"]';
        postURL = encodedURLfield.val();
    }

    PrimeFaces.debug('URL to post ' + postURL + '.');

    //partial ajax
    PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.PARTIAL_REQUEST_PARAM, true, parameterPrefix);

    //source
    PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.PARTIAL_SOURCE_PARAM, sourceId, parameterPrefix);

    //resetValues
    if (cfg.resetValues) {
        PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.RESET_VALUES_PARAM, true, parameterPrefix);
    }

    //ignoreAutoUpdate
    if (cfg.ignoreAutoUpdate) {
        PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.IGNORE_AUTO_UPDATE_PARAM, true, parameterPrefix);
    }

    //skip children
    if (cfg.skipChildren === false) {
        PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.SKIP_CHILDREN_PARAM, false, parameterPrefix);
    }

    //process
    var processArray = PrimeFaces.ajax.Request.resolveComponentsForAjaxCall(cfg, 'process');
    if(cfg.fragmentId) {
        processArray.push(cfg.fragmentId);
    }
    // default == @none
    var processIds = '@none';
    // use defined process + resolved keywords (@widget, PFS)?
    if (processArray.length > 0) {
        processIds = processArray.join(' ');
    }
    // fallback to @all if no process was defined by the user
    else {
        var definedProcess = PrimeFaces.ajax.Request.resolveComponentsForAjaxCall(cfg, 'process');
        definedProcess = $.trim(definedProcess);
        if (definedProcess === '') {
            processIds = '@all';
        }
    }
    if (processIds !== '@none') {
        PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.PARTIAL_PROCESS_PARAM, processIds, parameterPrefix);
    }

    //update
    var updateArray = PrimeFaces.ajax.Request.resolveComponentsForAjaxCall(cfg, 'update');
    if(cfg.fragmentId && cfg.fragmentUpdate) {
        updateArray.push(cfg.fragmentId);
    }
    if(updateArray.length > 0) {
        PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.PARTIAL_UPDATE_PARAM, updateArray.join(' '), parameterPrefix);
    }

    //behavior event
    if(cfg.event) {
        PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.BEHAVIOR_EVENT_PARAM, cfg.event, parameterPrefix);

        var domEvent = cfg.event;

        if(cfg.event === 'valueChange')
            domEvent = 'change';
        else if(cfg.event === 'action')
            domEvent = 'click';

        PrimeFaces.ajax.Request.addParam(postParams, PrimeFaces.PARTIAL_EVENT_PARAM, domEvent, parameterPrefix);
    }
    else {
        PrimeFaces.ajax.Request.addParam(postParams, sourceId, sourceId, parameterPrefix);
    }

    //params
    if(cfg.params) {
        PrimeFaces.ajax.Request.addParams(postParams, cfg.params, parameterPrefix);
    }
    if(cfg.ext && cfg.ext.params) {
        PrimeFaces.ajax.Request.addParams(postParams, cfg.ext.params, parameterPrefix);
    }

    /**
     * Only add params of process components and their children
     * if partial submit is enabled and there are components to process partially
     */
    if(cfg.partialSubmit && processIds.indexOf('@all') === -1) {
        var formProcessed = false,
            partialSubmitFilter = cfg.partialSubmitFilter||':input';

        if(processIds.indexOf('@none') === -1) {
            for (var i = 0; i < processArray.length; i++) {
                var jqProcess = $(PrimeFaces.escapeClientId(processArray[i]));
                var componentPostParams = null;

                if(jqProcess.is('form')) {
                    componentPostParams = jqProcess.serializeArray();
                    formProcessed = true;
                }
                else if(jqProcess.is(':input')) {
                    componentPostParams = jqProcess.serializeArray();
                }
                else {
                    componentPostParams = jqProcess.find(partialSubmitFilter).serializeArray();

                    //Rasp patched: Do not collect elements inside .skip-submission
                    componentPostParams = jqProcess
                        .find(partialSubmitFilter)
                        .filter(function(i, e) {
                            var skips = $(e).parentsUntil(jqProcess, '.skip-ajax-submission');
                            return skips.size() === 0 || (skips.size() === 1 && skips.get(0) === jqProcess);
                        })
                        .serializeArray();
                }

                $.merge(postParams, componentPostParams);
            }
        }

        //add form state if necessary
        if (!formProcessed) {
            PrimeFaces.ajax.Request.addParamFromInput(postParams, PrimeFaces.VIEW_STATE, form, parameterPrefix);
            PrimeFaces.ajax.Request.addParamFromInput(postParams, PrimeFaces.CLIENT_WINDOW, form, parameterPrefix);
            PrimeFaces.ajax.Request.addParamFromInput(postParams, 'dsPostWindowId', form, parameterPrefix);
            PrimeFaces.ajax.Request.addParamFromInput(postParams, 'dspwid', form, parameterPrefix);
        }

    }
    else {
        $.merge(postParams, form.serializeArray());
    }

    // remove postParam if already available in earlyPostParams
    if (PrimeFaces.settings.earlyPostParamEvaluation && cfg.earlyPostParams) {
        // loop early post params
        $.each(cfg.earlyPostParams, function(earlyPostParamIndex, earlyPostParam) {
            // loop post params and remove it, if it's the same param as the early post param
            postParams = $.grep(postParams, function(postParam, postParamIndex) {
                return postParam.name !== earlyPostParam.name;
            });
        });

        $.merge(postParams, cfg.earlyPostParams);
    }

    //serialize
    var postData = $.param(postParams);

    PrimeFaces.debug('Post Data:' + postData);

    var xhrOptions = {
        url : postURL,
        type : "POST",
        cache : false,
        dataType : "xml",
        data : postData,
        portletForms: portletFormsSelector,
        source: cfg.source,
        global: false,
        beforeSend: function(xhr, settings) {
            xhr.setRequestHeader('Faces-Request', 'partial/ajax');
            xhr.pfSettings = settings;
            xhr.pfArgs = {}; // default should be an empty object
            PrimeFaces.nonAjaxPosted = false;

            $(document).trigger('raspAjaxSend', [xhr, this]);
            if(global) {
                $(document).trigger('pfAjaxSend', [xhr, this]);
            }
        },
        error: function(xhr, status, errorThrown) {
            if(cfg.onerror) {
                cfg.onerror.call(this, xhr, status, errorThrown);
            }
            if(cfg.ext && cfg.ext.onerror) {
                cfg.ext.onerror.call(this, xhr, status, errorThrown);
            }

            $(document).trigger('raspAjaxError', [xhr, this, errorThrown]);
            if(global) {
                $(document).trigger('pfAjaxError', [xhr, this, errorThrown]);
            }

            PrimeFaces.error('Request return with error:' + status + '.');
        },
        success: function(data, status, xhr) {
            PrimeFaces.debug('Response received succesfully.');

            var parsed;

            //call user callback
            if(cfg.onsuccess) {
                parsed = cfg.onsuccess.call(this, data, status, xhr);
            }

            //extension callback that might parse response
            if(cfg.ext && cfg.ext.onsuccess && !parsed) {
                parsed = cfg.ext.onsuccess.call(this, data, status, xhr);
            }

            $(document).trigger('raspAjaxSuccess', [xhr, this]);
            if(global) {
                $(document).trigger('pfAjaxSuccess', [xhr, this]);
            }

            //do not execute default handler as response already has been parsed
            if(parsed) {
                return;
            }
            else {
                PrimeFaces.ajax.Response.handle(data, status, xhr);
            }

            PrimeFaces.debug('DOM is updated.');
        },
        complete: function(xhr, status) {
        	if(cfg.oncomplete) {
                cfg.oncomplete.call(this, xhr, status, xhr.pfArgs);
            }

            if(cfg.ext && cfg.ext.oncomplete) {
                cfg.ext.oncomplete.call(this, xhr, status, xhr.pfArgs);
            }

            $(document).trigger('raspAjaxComplete', [xhr, this]);
            if(global) {
                $(document).trigger('pfAjaxComplete', [xhr, this]);
            }

            PrimeFaces.debug('Response completed.');

            PrimeFaces.ajax.Queue.removeXHR(xhr);

            if(!cfg.async && !PrimeFaces.nonAjaxPosted) {
                PrimeFaces.ajax.Queue.poll();
            }
        }
    };

    if (cfg.timeout) {
        xhrOptions['timeout'] = cfg.timeout;
    }

    PrimeFaces.ajax.Queue.addXHR($.ajax(xhrOptions));
};

//Patch for autocomplete - do not search with 'enter' key in keyup search mode
//(function() {
//    var wrapped = PrimeFaces.widget.AutoComplete.prototype.processKeyEvent;
//    PrimeFaces.widget.AutoComplete.prototype.processKeyEvent = function(e) {
//        //debugger;
//        if(this.cfg.queryEvent !== 'enter') {
//            //console.log(this.cfg.queryEvent);
//            var keyCode = $.ui.keyCode;
//            var key = e.which;
//            if(key === keyCode.ENTER || key === keyCode.NUMPAD_ENTER){
//                e.preventDefault();
//                return
//            }
//        }
//        wrapped.apply(this, arguments);
//    }
//})();
